import React from 'react'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../../../components/ui/accordion'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../../components/ui/table'
import { InfoIcon, MailIcon, PhoneIcon, SmartphoneIcon, UserRoundIcon } from 'lucide-react'
import { Button } from '../../../../components/ui/button'
import { Link } from 'react-router-dom'
import { Trans, useLingui } from "@lingui/react/macro"

type Props = {
  intervention: Intervention

}

const Info = ({intervention}:Props) => {
  const { t } = useLingui()
  
  return (
    <>
    <Accordion type='multiple' defaultValue={['customer-data', 'description', 'internal-remark']} className='flex flex-col gap-2'>
        <AccordionItem value='customer-data' className='border rounded-md'>
          <AccordionTrigger className='p-2 hover:no-underline'>
            <div className='flex flex-col text-left'>
              <p className='text-sm font-semibold'><Trans>Klant gegevens</Trans></p>
              <p className='text-sm text-neutral-400'><Trans>De algemene gegevens van de klant voor deze interventie</Trans></p>
            </div>
          </AccordionTrigger>
          <AccordionContent className='p-2'>
            <ul className='pl-4 list-disc'>
              <li>{intervention?.m_oKLANT?.m_sNAAM}</li>
              <li>{intervention?.m_oKLANT?.m_sADRES1} {intervention?.m_oKLANT?.m_sNR}</li>
              <li>{intervention?.m_oKLANT?.m_sPOSTCODE} {intervention?.m_oKLANT?.m_sSTAD}</li>      
            </ul>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead></TableHead>
                  <TableHead><Trans>Contact</Trans></TableHead>
                  <TableHead><Trans>Beller</Trans></TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell><UserRoundIcon className='w-4 h-4 text-neutral-400'/></TableCell>
                  <TableCell>{intervention?.m_sCONTACT || t`Geen naam`}</TableCell>
                  <TableCell>{intervention?.m_sCALLER || t`Geen naam`}</TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell><MailIcon className='w-4 h-4 text-neutral-400'/></TableCell>
                  <TableCell>{intervention?.m_sEMAIL || t`Geen e-mail`}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell><PhoneIcon className='w-4 h-4 text-neutral-400'/></TableCell>
                  <TableCell>{intervention?.m_sTEL || t`Geen telefoonnummer`}</TableCell>
                  <TableCell>{intervention?.m_sCALLERPHONE || t`Geen telefoonnummer`}</TableCell>
                </TableRow>
                
                <TableRow>
                  <TableCell><SmartphoneIcon className='w-4 h-4 text-neutral-400'/></TableCell>
                  <TableCell>{intervention?.m_sGSM || t`Geen gsm nummer`}</TableCell>
                  <TableCell></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value='extra-contacts' className='border rounded-md'>
          <AccordionTrigger className='p-2 hover:no-underline'>
            <div className='flex flex-col text-left'>
              <p className='text-sm font-semibold'><Trans>Extra contactpersonen</Trans></p>
              {(!intervention?.m_aCONTACTS || intervention?.m_aCONTACTS?.length === 0) 
              ? <p className='text-sm text-neutral-400'><Trans>Er zijn geen contactpersonen gevonden</Trans></p>
              : <p className='text-sm text-neutral-400'><Trans>{intervention?.m_aCONTACTS?.length || 0} contactpersonen gevonden</Trans></p>
              }      
            </div>
          </AccordionTrigger>
          <AccordionContent className='p-2'>
          {(Array.isArray(intervention?.m_aCONTACTS) && intervention?.m_aCONTACTS?.length > 0) &&
              <div className='overflow-auto'>
               <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead><Trans>Naam</Trans></TableHead>
                    <TableHead><Trans>E-mail</Trans></TableHead>
                    <TableHead><Trans>Functie</Trans></TableHead>
                    <TableHead><Trans>Gsm nummer</Trans></TableHead>
                    <TableHead><Trans>Telefoon nummer</Trans></TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {intervention?.m_aCONTACTS?.map((contact: any) => (
                    <TableRow key={contact?.m_iCONTACTPERSONID.toString()}>
                      <TableCell className='whitespace-nowrap'>{contact?.m_sNAME || t`Geen naam`}</TableCell>
                      <TableCell className='whitespace-nowrap'>{contact?.m_sEMAIL || t`Geen e-mail`}</TableCell>
                      <TableCell className='whitespace-nowrap'>{contact?.m_sFUNCTIE || t`Geen functie`}</TableCell>
                      <TableCell className='whitespace-nowrap'>{contact?.m_sTELMOBILE || t`Geen gsm nummer`}</TableCell>
                      <TableCell className='whitespace-nowrap'>{contact?.m_sTEL || t`Geen telefoon nummer`}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              </div>
            }
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value='technical-unit-data' className='border rounded-md'>
          <AccordionTrigger className='p-2 hover:no-underline'>
            <div className='flex flex-col text-left'>
              <p className='text-sm font-semibold'><Trans>Technische eenheid gegevens</Trans></p>
              {(!intervention?.m_aMACHINES || intervention?.m_aMACHINES?.length === 0) 
              ? <p className='text-sm text-neutral-400'><Trans>Er zijn geen technische eenheid gegevens gevonden</Trans></p>
              : <p className='text-sm text-neutral-400'><Trans>{intervention?.m_aMACHINES?.length} technische eenheid gegevens gevonden</Trans></p>
              }                          
            </div>
          </AccordionTrigger>
          <AccordionContent className='p-2'>
            {(Array.isArray(intervention?.m_aMACHINES) && intervention.m_aMACHINES.length > 0) &&
            <div>
              {intervention.m_aMACHINES.map((machine:any) => (
                <div key={machine.m_iMACHINEID.toString()} className='flex flex-col gap-2 mt-4 first:mt-0'>
                  <div className='py-1 border-b'>
                    <p className='w-full font-semibold'>{machine?.m_sMERK} - {machine?.m_sTYPEDESCRIPTION}</p>
                  </div>

                  <div>
                    <p className='text-sm font-medium text-neutral-800'><Trans>Bouwjaar</Trans></p>
                    <p>{machine?.m_sBOUWJAAR || t`Geen bouwjaar`}</p>
                  </div>
                  
                  <div>
                    <p className='text-sm font-medium text-neutral-800'><Trans>Serienummer</Trans></p>
                    <p>{machine?.m_sSERIENR || t`Geen serienummer`}</p>
                  </div>

                  <div>
                    <p className='text-sm font-medium text-neutral-800'><Trans>Onderhoudscontract</Trans></p>
                    <p>{machine?.m_sOHC || t`Geen onderhoudscontract`}</p>
                  </div>
                  
                  <div>
                    <p className='text-sm font-medium text-neutral-800'><Trans>Locatie info</Trans></p>
                    <p>{machine?.m_sLOCATIONINFO || t`Geen info`}</p>
                  </div>
                </div>
              ))}
            </div>
            }
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value='description' className='border rounded-md'>
          <AccordionTrigger className='p-2 hover:no-underline'>
            <div className='flex flex-col text-left'>
              <p className='text-sm font-semibold'><Trans>Omschrijving</Trans></p>
              <p className='text-sm text-neutral-400'>Call id: {intervention?.m_iCALLID} ({intervention?.m_sEXTNUMMER})</p>
            </div>
          </AccordionTrigger>
          <AccordionContent className='p-2'>
            <div className='flex items-center justify-between py-2 border-b'>
              <p className='font-medium text-neutral-500'>Call id</p>
              <p className='font-medium text-neutral-800'>{intervention?.m_iCALLID}</p>
            </div>
            <div className='flex items-center justify-between py-2 border-b'>
              <p className='font-medium text-neutral-500'><Trans>Projectleider</Trans></p>
              <p className='font-medium text-neutral-800'>{intervention?.m_sPROJECTLEADER}</p>
            </div>
            <div className='flex items-center justify-between py-2 border-b'>
              <p className='font-medium text-neutral-500'><Trans>Reden bezoek</Trans></p>
              <p className='font-medium text-neutral-800'>{intervention?.m_sREDENBEZOEK}</p>
            </div>
            <p className='my-2 whitespace-pre-line'>{intervention?.m_sOMSCHRIJVING}</p>

            {('m_sJITBITURL' in intervention && typeof intervention?.m_sJITBITURL === 'string' && intervention?.m_sJITBITURL) &&
            <div className='flex items-center gap-2'>
              <InfoIcon className='w-4 h-4 text-neutral-500'/>
              <Link to={intervention.m_sJITBITURL} target="_blank" className='underline text-primary'>{intervention.m_sJITBITURL}</Link>
            </div>
            }

            <Link to={`/startpagina/bill-of-materials?callid=${intervention?.m_iCALLID}`}><Button variant='secondary' className='w-full'><Trans>Bill of materials</Trans></Button></Link>
          </AccordionContent>
        </AccordionItem>

        <AccordionItem value='internal-remark' className='border rounded-md'>
          <AccordionTrigger className='p-2 hover:no-underline'>
            <div className='flex flex-col text-left'>
              <p className='text-sm font-semibold'><Trans>Interne commentaar</Trans></p>
              {(!intervention?.m_sINTCOMM || intervention?.m_sINTCOMM === '') && <p className='text-sm text-gray-500'><Trans>Geen interne commentaar</Trans></p>}
            </div>
          </AccordionTrigger>
          <AccordionContent className='p-2'>
            <p>{intervention?.m_sINTCOMM}</p>
          </AccordionContent>
        </AccordionItem>
    </Accordion>
    </>
  )
}

export default Info